import { styled } from 'linaria/react';

export const Container = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 2;

  display: flex;
  align-items: center;

  min-height: 112px;
  padding: var(--space-400);
  background-color: var(--background-primary);
  box-shadow: var(--box-shadow-m);

  @media (--only-mobile) {
    min-height: 90px;
    padding: var(--space-200);
  }
`;
